/**
 * StrategicNominationBadge
 *
 * Shown on items that were seeded by the executive who tossed the ball.
 * Provides visual distinction without biasing judgment (items are still
 * ranked on their merits alongside all others).
 */

import { Star } from 'lucide-react';

interface StrategicNominationBadgeProps {
  /** Optional cycle name for the tooltip */
  cycleName?: string;
  /** "inline" shows an icon+label inline; "icon" shows icon only */
  variant?: 'inline' | 'icon';
  className?: string;
}

export function StrategicNominationBadge({
  cycleName,
  variant = 'inline',
  className = '',
}: StrategicNominationBadgeProps) {
  const tooltip = cycleName
    ? `Strategically nominated — seeded by the executive for ${cycleName}`
    : 'Strategically nominated — seeded by the executive who tossed the ball';

  if (variant === 'icon') {
    return (
      <span
        title={tooltip}
        className={`inline-flex items-center text-[var(--mustard)] ${className}`}
        aria-label={tooltip}
      >
        <Star className="h-3.5 w-3.5 fill-amber-400 stroke-amber-500" />
      </span>
    );
  }

  return (
    <span
      title={tooltip}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-[var(--mustard-dim)] text-[var(--mustard)] border border-[var(--mustard)] ${className}`}
    >
      <Star className="h-3 w-3 fill-amber-400 stroke-amber-500 flex-shrink-0" />
      Strategic
    </span>
  );
}
